interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  // If you also have optional fields like measurementId, add them here:
  // measurementId?: string;
}

// 2. Create your actual config object
const firebaseConfig: FirebaseConfig = {
  apiKey: "AIzaSyD7BdnDjSG_l3oYsKXaT7llZVle7fiCBSs",
  authDomain: "saas-video-9ab18.firebaseapp.com",
  projectId: "saas-video-9ab18",
  storageBucket: "saas-video-9ab18.firebasestorage.app",
  messagingSenderId: "97380220730",
  appId: "1:97380220730:web:386a0989a4eb03a230da03",
};

// 3. Provide a getter function that throws an error if no config is found
export function getFirebaseConfig(): FirebaseConfig {
  if (!firebaseConfig || !firebaseConfig.apiKey) {
    throw new Error(
      'No Firebase configuration object provided.\n' +
        'Add your web app’s configuration object to firebaseConfig.ts'
    );
  }
  return firebaseConfig;
}
